import { createFileRoute } from "@tanstack/react-router";

import { Login } from "../../pages/Auth";

export const Route = createFileRoute("/auth/login")({
  validateSearch: (search: Record<string, unknown>) => ({
    from: typeof search.from === "string" ? search.from : undefined,
  }),
  component: Login,
});
